const TRANSPARENCY_REPORT_START_YEAR = 2025

export function getCompletedQuarterOptions(): Array<{
  label: string
  value: number
}> {
  const now = new Date()
  const options: Array<{ label: string; value: number }> = []
  let year = TRANSPARENCY_REPORT_START_YEAR
  let quarter = 1

  while (true) {
    const availableFrom = new Date(year, quarter * 3, 1)
    availableFrom.setDate(availableFrom.getDate() - 15)
    if (now < availableFrom) break
    options.push({ label: `Q${quarter} ${year}`, value: year * 10 + quarter })
    quarter++
    if (quarter > 4) {
      quarter = 1
      year++
    }
  }

  return options
}
